import { Observable } from 'rxjs'
import {
  setHeadlineContent,
  setEditorContentState,
  setCharmBarContent,
} from '~/redux/draftEditor'
import { setStoryData } from '~/redux/storyData'
import { errorAction } from '~/redux/commonActions'
import {
  ansToDraftContent,
  ansToHeadlineContent,
} from '~/reactapp/story/import/ansToDraftContent'
import ansToStoryData from '~/reactapp/story/import/ansToStoryData'
import {
  ACTION_ACTIVE_TAB,
  EllipsisTabs,
  ACTION_STORY_LOADED,
} from '~/redux/appReducer'
const storyEpic = (action$, store, { serviceResolver, featureFlag }) =>
  action$
    .filter((action) => {
      const storyLoaded = action.type === ACTION_STORY_LOADED
      const swithedToComposeTab =
        action.type === ACTION_ACTIVE_TAB &&
        action.payload === EllipsisTabs.Compose
      return storyLoaded || swithedToComposeTab
    })
    .mergeMap((action) => {
      // If it's actual story load, return it back
      if (action.type === ACTION_STORY_LOADED) {
        return Observable.of(action)
      }
      // If it switch to compose tab otherwice, fake it
      const storyService = serviceResolver('storyService')
      return Observable.from(storyService.getStory()).map((story) => {
        return {
          payload: story,
          updateHeadlineOnly: true,
        }
      })
    })
    .mergeMap(async (action) => {
      try {
        const headlineContent = await ansToHeadlineContent(action.payload)
        if (action.updateHeadlineOnly) {
          return {
            headlineContent,
            updateHeadlineOnly: true,
          }
        }
        const draftContent = ansToDraftContent(action.payload)
        return {
          draftContent,
          headlineContent,
          storyData: ansToStoryData(action.payload),
        }
      } catch (error) {
        return error
      }
    })
    .mergeMap((draftContentOrError) => {
      if (draftContentOrError instanceof Error) {
        return Observable.of(errorAction(draftContentOrError))
      } else {
        const headlineAction = [
          setHeadlineContent(draftContentOrError.headlineContent),
        ]
        return Observable.from(
          draftContentOrError.updateHeadlineOnly
            ? headlineAction
            : headlineAction.concat([
                setEditorContentState(draftContentOrError.draftContent),
                setCharmBarContent(draftContentOrError.draftContent),
                setStoryData(draftContentOrError.storyData),
              ])
        )
      }
    })

export default storyEpic
